module.exports = __webpack_public_path__ + "static/Calibre-Light-62b8f0fd78f4d842b3a75c1d2512e449.woff";